import styled from "styled-components";

const StyledComponentsDiv = styled.div`
    &.frame-313342,
    &.frame-313342 * {
        box-sizing: border-box;
    }
    &.frame-313342 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .quick-q-a {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 28px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-313376 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313382 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        width: 196px;
        height: 52px;
        position: relative;
    }
    .general-questions {
        text-align: center;
        font-family: "Roboto-Medium", sans-serif;
        font-size: 15px;
        letter-spacing: 0.0125em;
        font-weight: 500;
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    /* .frame-313382.active {
        border-style: solid;
        border-color: #00aeef;
        border-width: 0px 0px 4px 0px;
    } */
    .border-bottom {
        width: 100%;
        height: 4px;
        background-color: transparent;
    }
    .border-bottom.active {
        background-color: #00aeef;
    }
    .general-questions.active {
        color: var(--text-and-icons-blue-500, #00aeef);
    }
`;

export default function QandAHeaderComponent({ handleTab, activeTab }) {
    const tabs = [
        { key: "tutorials", label: "Tutorials", isDisabled: false },
        { key: "integrations", label: "Integrations", isDisabled: false },
        { key: "connections", label: "Connections", isDisabled: true },
        { key: "qna", label: "Q&A", isDisabled: true }
    ];

    return (
        <StyledComponentsDiv className="frame-313342">
            <div className="frame-313376">
                {tabs.map(tab => (
                    <div
                        key={tab.key}
                        className="frame-313382"
                        onClick={() => {
                            if (!tab.isDisabled) handleTab(tab.key);
                        }}>
                        <div className={`general-questions ${activeTab === tab.key ? " active" : ""}`}>{tab.label}</div>
                        <div className={`border-bottom ${activeTab === tab.key ? " active" : ""}`}></div>
                    </div>
                ))}
            </div>
        </StyledComponentsDiv>
    );
}
